
import React from 'react';

type Props = {
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

type State = {
    hasError: boolean;
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
    logs: any[]
};

export class ErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false, error: null, errorInfo: null, logs:[] };

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        const log = {
            message: error.message,
            stack: error.stack,
            componentStack: errorInfo.componentStack,
            time: new Date().toISOString(),
        };
        console.log(log);
        this.setState({ hasError: true, error, errorInfo, logs: [...this.state.logs, log] });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || <h1>Что-то пошло не так.</h1>;
        }
        return this.props.children;
    }
}